export enum HsbcInstallmentTerm {
  HSBC_INSTALLMENT_3M = 'HSBC Installment 3M',
  HSBC_INSTALLMENT_6M = 'HSBC Installment 6M',
  HSBC_INSTALLMENT_9M = 'HSBC Installment 9M',
  HSBC_INSTALLMENT_12M = 'HSBC Installment 12M',
  HSBC_INSTALLMENT_18M = 'HSBC Installment 18M',
  HSBC_INSTALLMENT_24M = 'HSBC Installment 24M',
  HSBC_INSTALLMENT_36M = 'HSBC Installment 36M'
}
